import React from "react";

import { css } from "@compiled/react";
import { UniformSlot } from "@uniformdev/canvas-react";

type UniformSplitColorBackgroundContainerProps = {
    topColor: string;
    bottomColor: string;
    padding?: string;
};

const UniformSplitColorBackgroundContainer: React.FC<
    UniformSplitColorBackgroundContainerProps
> = ({ topColor, bottomColor, padding = "40px" }) => {
    const colorStyle = css({
        background: `linear-gradient(to bottom, ${topColor} 0%, ${topColor} 50%, ${bottomColor} 50%, ${bottomColor} 100%)`
    });

    return (
        <div>
            <div css={[{ padding }, colorStyle]}>
                <UniformSlot name="component" />
            </div>
        </div>
    );
};

export default UniformSplitColorBackgroundContainer;
